/**
 * Floating Secret Sale return control — active session only.
 * Never extends or restarts the session; reads SmilodoxSecretSaleSession only.
 */
(function () {
  "use strict";

  var HIDE_SELECTORS = [
    "cart-drawer[open]",
    "cart-drawer.is-open",
    ".cart-drawer.is-open",
    "dialog[open]",
    ".modal[open]",
    ".drawer[open]",
    ".product-sticky-add-to-cart.is-visible",
  ];

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
      return;
    }
    fn();
  }

  function SmilodoxSecretSaleFloat(root) {
    this.root = root;
    this.linkEl = root.querySelector("[data-ssf-link]");
    this.codeEl = root.querySelector("[data-ssf-code]");
    this.percentEl = root.querySelector("[data-ssf-percent]");
    this.mmEl = root.querySelector("[data-ssf-mm]");
    this.ssEl = root.querySelector("[data-ssf-ss]");

    this.campaignKey = root.getAttribute("data-campaign-key") || "";
    this.hideOnSecretSale = root.getAttribute("data-hide-on-secret-sale") !== "false";
    this.currentHandle = root.getAttribute("data-current-handle") || "";
    this.tickerId = null;
    this.stickyObservers = [];
    this.destroyed = false;

    this.tick = this.tick.bind(this);
    this.sync = this.sync.bind(this);
    this.onDialogBeforeShow = this.onDialogBeforeShow.bind(this);
    this.onDialogAfterHide = this.onDialogAfterHide.bind(this);
  }

  SmilodoxSecretSaleFloat.prototype.api = function () {
    return window.SmilodoxSecretSaleSession || null;
  };

  SmilodoxSecretSaleFloat.prototype.pageBlocksFloat = function () {
    if (this.hideOnSecretSale) {
      var api = this.api();
      if (api && api.isSecretSaleHandle(this.currentHandle)) return true;
      if (document.body.classList.contains("template-collection-secret-sale")) return true;
    }
    for (var i = 0; i < HIDE_SELECTORS.length; i++) {
      if (document.querySelector(HIDE_SELECTORS[i])) return true;
    }
    return false;
  };

  SmilodoxSecretSaleFloat.prototype.setVisible = function (visible) {
    var isVisible = !this.root.hasAttribute("hidden");
    if (visible === isVisible) return;
    if (visible) {
      this.root.removeAttribute("hidden");
      this.root.setAttribute("data-ssf-visible", "true");
    } else {
      this.root.setAttribute("hidden", "");
      this.root.removeAttribute("data-ssf-visible");
    }
  };

  SmilodoxSecretSaleFloat.prototype.render = function (active) {
    if (!active || this.pageBlocksFloat()) {
      this.setVisible(false);
      return;
    }

    var api = this.api();
    var url = api ? api.collectionUrl(active.lastCollectionHandle) : "/collections/secret-sale";
    var clock = api ? api.formatClock(active.remainingMs) : { mm: "00", ss: "00", totalSec: 0 };

    if (this.linkEl) this.linkEl.setAttribute("href", url);
    if (this.codeEl) this.codeEl.textContent = active.code || "";
    if (this.percentEl) this.percentEl.textContent = active.percent ? String(active.percent) + "%" : "";
    if (this.mmEl) this.mmEl.textContent = clock.mm;
    if (this.ssEl) this.ssEl.textContent = clock.ss;

    this.setVisible(clock.totalSec > 0);
  };

  SmilodoxSecretSaleFloat.prototype.tick = function () {
    if (this.destroyed) return;
    var api = this.api();
    if (!api) {
      this.setVisible(false);
      return;
    }
    this.render(api.getActive(this.campaignKey));
  };

  SmilodoxSecretSaleFloat.prototype.sync = function () {
    this.tick();
  };

  SmilodoxSecretSaleFloat.prototype.onDialogBeforeShow = function () {
    this.setVisible(false);
  };

  SmilodoxSecretSaleFloat.prototype.onDialogAfterHide = function () {
    this.sync();
  };

  SmilodoxSecretSaleFloat.prototype.startTicker = function () {
    if (this.tickerId) return;
    this.tickerId = window.setInterval(this.tick, 1000);
  };

  SmilodoxSecretSaleFloat.prototype.init = function () {
    var self = this;
    this.sync();
    this.startTicker();

    var api = this.api();
    if (api && api.onChange) {
      this.unsubscribe = api.onChange(function () {
        self.sync();
      });
    }

    document.addEventListener("dialog:before-show", this.onDialogBeforeShow, true);
    document.addEventListener("dialog:after-hide", this.onDialogAfterHide, true);

    document.querySelectorAll(".product-sticky-add-to-cart").forEach(function (element) {
      try {
        var observer = new MutationObserver(function () {
          self.sync();
        });
        observer.observe(element, {
          attributes: true,
          attributeFilter: ["class"],
        });
        self.stickyObservers.push(observer);
      } catch (e) {}
    });
  };

  SmilodoxSecretSaleFloat.prototype.destroy = function () {
    this.destroyed = true;
    if (this.tickerId) clearInterval(this.tickerId);
    if (typeof this.unsubscribe === "function") this.unsubscribe();
    document.removeEventListener("dialog:before-show", this.onDialogBeforeShow, true);
    document.removeEventListener("dialog:after-hide", this.onDialogAfterHide, true);
    this.stickyObservers.forEach(function (observer) {
      observer.disconnect();
    });
    this.stickyObservers = [];
  };

  ready(function () {
    var root = document.querySelector("[data-ssf-root]");
    if (!root || root.__ssfInstance) return;
    var instance = new SmilodoxSecretSaleFloat(root);
    root.__ssfInstance = instance;
    instance.init();
  });
})();
